import {
    setCursor,
    setZeroCursor,
    prototypeSetData,
    prototypeSetTotalCount,
    prototypeAppendData,
    prototypeSetBusy,
    prototypeSetMarkers,
    prototypeSetInitLoad,
    prototypeSetCanLoadMore,
} from './prototypes'

export const SPORT_VENUES_SET_CURSOR = 'SPORT_VENUES_SET_CURSOR'
export const SPORT_VENUES_SET_ZERO_CURSOR = 'SPORT_VENUES_SET_ZERO_CURSOR'
export const SPORT_VENUES_SET_DATA = 'SPORT_VENUES_SET_DATA'
export const SPORT_VENUES_TYPES_SET_DATA = 'SPORT_VENUES_TYPES_SET_DATA'
export const SPORT_VENUES_SET_TOTAL_COUNT = 'SPORT_VENUES_SET_TOTAL_COUNT'
export const SPORT_VENUES_APPEND_DATA = 'SPORT_VENUES_APPEND_DATA'
export const SPORT_VENUES_SET_BUSY = 'SPORT_VENUES_SET_BUSY'
export const SPORT_VENUES_TYPES_SET_BUSY = 'SPORT_VENUES_TYPES_SET_BUSY'
export const SPORT_VENUES_SET_MARKERS = 'SPORT_VENUES_SET_MARKERS'
export const SPORT_VENUES_SET_INIT_LOAD = 'SPORT_VENUES_SET_INIT_LOAD'
export const SPORT_VENUES_SET_CAN_LOAD_MORE = 'SPORT_VENUES_SET_CAN_LOAD_MORE'
export const SPORT_VENUES_TYPES_APPLY = 'SPORT_VENUES_TYPES_APPLY'

export const INVESTMENT_STORE_KEY = 'investment'

/**
 * Set busy in types section
 *
 * @param {Object} state
 * @param {string} actionType
 * @param {string} busy
 */
function prototypeSetBusyType(state, actionType, busy) {
    return {
        ...state,
        types: {
            ...state.types,
            [actionType]: {
                ...state?.types?.[actionType],
                busy: busy,
            },
        },
    }
}

/**
 * Set data in types section
 *
 * @param {Object} state
 * @param {string} actionType
 * @param {Object} data
 */
function prototypeSetTypesData(state, actionType, data) {
    return {
        ...state,
        types: {
            ...state.types,
            [actionType]: {
                ...state?.types?.[actionType],
                ...data,
            },
        },
    }
}

/**
 * Set data in types section
 *
 * @param {Object} state
 * @param {string} actionType
 */
function prototypeApplyTypes(state, actionType) {
    return {
        ...state,
        types: {
            ...state.types,
            [actionType]: {
                ...state?.types?.[actionType],
                apply: true,
            },
        },
    }
}

/**
 * @param {Object} state
 * @param {Object} action
 * @return {*}
 */
export default function (state = [], action) {
    switch (action.type) {
        case SPORT_VENUES_SET_CURSOR: return setCursor(state, action.cursor)
        case SPORT_VENUES_SET_ZERO_CURSOR: return setZeroCursor(state)
        case SPORT_VENUES_SET_DATA: return prototypeSetData(state, action.data)
        case SPORT_VENUES_TYPES_SET_DATA: return prototypeSetTypesData(state, action.actionType, action.data)
        case SPORT_VENUES_SET_TOTAL_COUNT: return prototypeSetTotalCount(state, action.count)
        case SPORT_VENUES_APPEND_DATA: return prototypeAppendData(state, 'sportVenues', action.data)
        case SPORT_VENUES_SET_BUSY: return prototypeSetBusy(state, action.busy)
        case SPORT_VENUES_TYPES_SET_BUSY: return prototypeSetBusyType(state, action.actionType, action.busy)
        case SPORT_VENUES_SET_MARKERS: return prototypeSetMarkers(state, action.markers)
        case SPORT_VENUES_SET_INIT_LOAD: return prototypeSetInitLoad(state, action.initLoad)
        case SPORT_VENUES_SET_CAN_LOAD_MORE: return prototypeSetCanLoadMore(state, action.canLoadMore)
        case SPORT_VENUES_TYPES_APPLY: return prototypeApplyTypes(state, action.actionType)
        default: return state
    }
}
